import { ArrowUturnLeftIcon, CheckIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import { formatDateTime } from "@utils/utils";
import { parseISO } from "date-fns";
import React from "react";

import { Tooltip } from "@fronterahealth/frontera-ui-components";
import { PopoverMenu } from "@fronterahealth/frontera-ui-components/PopoverActionMenu/PopoverActionMenu";

interface ApprovalBannerProps {
  approvedAt?: string | null;
  onRevoke?: () => void;
}

export const ApprovalBanner: React.FC<ApprovalBannerProps> = ({ approvedAt, onRevoke }) => {
  const formattedDate = approvedAt ? formatDateTime(parseISO(approvedAt)) : null;

  return (
    <div className="flex w-full items-center gap-4 bg-green-700 px-6 min-h-12 animate-approval-banner-in">
      <div className="flex flex-1 items-center gap-2">
        <CheckIcon className="h-4 w-4 shrink-0 text-white" />
        <span className="text-sm font-normal leading-[22px] text-white">
          {formattedDate ? `Approved on ${formattedDate}` : "Approved"}
        </span>
        <Tooltip
          showInfoIcon={false}
          placement="bottom"
          text="Approved goals and targets cannot be edited. Revoke approval to make changes. Approved data will not be affected by program refresh."
        >
          <InformationCircleIcon className="h-5 w-5 cursor-pointer text-white" />
        </Tooltip>
      </div>
      <div className="[&_[data-testid='popover-trigger']:hover]:bg-green-900!">
        <PopoverMenu
          menuItems={[
            {
              label: "Revoke approval",
              Icon: ArrowUturnLeftIcon,
              callback: onRevoke,
            },
          ]}
          openDirection="to-bottom-left"
          mode="primary"
          useSelectButton={false}
          iconClassName="text-white"
        />
      </div>
    </div>
  );
};
